import { forwardRef, type Ref, type SVGProps } from "react";
const IconBuildingsOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M23 26a1 1 0 0 1-1-1V12a1 1 0 0 1 2 0v13a1 1 0 0 1-1 1" />
    <path d="M26.72 6.82 14.36 2.07a1 1 0 0 0-.93.11A1 1 0 0 0 13 3v9H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V8.69a2 2 0 0 0-1.28-1.87M6 28V14h9v14Zm20 0h-9V14a2 2 0 0 0-2-2V4.46l11 4.23Z" />
    <rect width={2} height={17} x={18} y={9} rx={1} />
    <rect width={5} height={2} x={8} y={16} rx={1} />
    <rect width={5} height={2} x={8} y={20} rx={1} />
    <rect width={5} height={2} x={8} y={24} rx={1} />
  </svg>
);
const ForwardRef = forwardRef(IconBuildingsOutlineSVG);
ForwardRef.displayName = "IconBuildingsOutline";
export { ForwardRef as IconBuildingsOutline };
